import React, {FC} from 'react';
import styled from 'styled-components';

import {Plural} from '../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {CellsContext} from '../../../../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {ViewerPanelId} from '../../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {Dropdown} from '../../../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {Anchor} from '../../../../../../../libs/shared/ui/src/components/reposition/repositionHelpers';
import {fontWeights} from '../../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ConversationHeaderAiSimilarDropdownConversationContainer} from './conversationHeaderAiSimilarDropdownConversationContainer';

/*
 * Props.
 */

interface ConversationHeaderAiSimilarDropdownProps {
  anchor: Anchor;
  conversationIds: ReadonlyArray<number>;
  cellsContext: CellsContext;
  panelId: ViewerPanelId;
}

/*
 * Style.
 */

const StyledSimilarConversationsHeaderDiv = styled.div`
  padding: 16px 16px 11px 16px;
  font-weight: ${fontWeights.semibold};
  line-height: 16px;
`;

const StyledConversationsWrapperDiv = styled.div`
  display: flex;
  flex-flow: column;
  padding: 0 16px 16px 16px;
  gap: 8px;
  overflow: auto;
`;

/*
 * Component.
 */

export const ConversationHeaderAiSimilarDropdown: FC<ConversationHeaderAiSimilarDropdownProps> = (props) => {
  const {anchor, conversationIds, cellsContext, panelId} = props;

  return (
    <Dropdown
      anchor={anchor}
      placement="bottom-start"
      isExclusive={false}
      isInline
      width={300}
      maxHeight={328}
    >
      <StyledSimilarConversationsHeaderDiv>
        <Plural
          id="conversation-hedaer-ai-similar-converstaions"
          value={conversationIds.length}
          one="# similar conversation"
          other="# similar conversations"
        />
      </StyledSimilarConversationsHeaderDiv>
      <StyledConversationsWrapperDiv>
        {conversationIds.map((conversationId, index) => (
          <ConversationHeaderAiSimilarDropdownConversationContainer
            key={conversationId}
            panelId={panelId}
            conversationId={conversationId}
            cellsContext={cellsContext}
            index={index}
          />
        ))}
      </StyledConversationsWrapperDiv>
    </Dropdown>
  );
};
